module.exports = __webpack_public_path__ + "img/information.66b9190a.svg";